<template>
  <div class="boxs">
    <div class="seachBox flex" @keydown="searchKey">
      <div class="seachList" style="display: none;"><span class="name">客户名称：</span>
        <a-select
            placeholder="请输入客户名称"
            v-model="seach.a_customer_id" class="seachs"
            :default-active-first-option="false"
            :filter-option="false"
            :not-found-content="null"
            :options="options"
            :show-arrow="false"
            show-search
            @change="handleChange"
            @search="handleSearch"
        >
        </a-select>
      </div>
      <div class="seachList"><span class="name">关键词：</span>
        <a-input placeholder="请输入单页名称" class="seachs" v-model="seach.name"/>
      </div>
      <div class="seachList">
        <span class="name">改写日期：</span>
        <a-range-picker
            class="seachs"
            v-model="seach.create_time"
            :allowClear="true"
            :showTime="false"
            format="YYYY-MM-DD"
        />
      </div>
      <div class="seachList">
        <span class="name">改写状态：</span>
        <a-select
            v-model="seach.status"
            class="seachs"
            allowClear
            placeholder="请选择"
        >
          <a-select-option :value="item.id" v-for="item in seachList.status">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>

      <div class="seachList">
        <a-button type="primary" size="default" class="seachBtn" @click="getList(1)" style="margin-right: 15px">
          查询
        </a-button>
        <a-button size="default" class="seachBtn" @click="resetSeach()">重置</a-button>
      </div>
      <div class="seachList no"></div>
    </div>

    <div style="margin-bottom: 12px">
      <a-button class="top_btn"  @click="submitchange()">
        批量改写
      </a-button>
      <span style="margin-left: 8px">
          <template v-if="hasSelected">
            {{ `选中 ${product_ids.length} 项` }}
          </template>
        </span>
    </div>
    <a-table :columns="columns" :data-source="data" :pagination="false" rowKey="id" :loading="loadingtable"
             :row-selection="{ selectedRowKeys: product_ids, onChange: onSelectChange,onSelect:onSelectRow, }" v-if="data.length>0">
      <span slot="name" slot-scope="text">
        <a :href="text.show_url" target="_blank">{{ text.name }}</a>
      </span>
      <span slot="action" slot-scope="text">
        <a @click="submitchange(text.id, text.a_customer_id)" v-if="text.status == 3">继续改写</a>
         <a-popconfirm
             v-if="text.status == 2"
             title="此操作将撤回改写, 是否继续?"
             ok-text="确定"
             cancel-text="取消"
             @confirm="submitchange2(text.id)"
             @cancel="()=>{}"
         >
          <a>撤回改写</a>
        </a-popconfirm>
      </span>
    </a-table>
    <a-empty v-else  :description="description" />
    </div>
</template>

<script>
import {debounce} from "../../../../utils/utils"
import API from "../api";
const columns = [
  {
    title: "单页名称",
    key: "name",
    scopedSlots: { customRender: "name" }
  },
  {
    title: "改写时间",
    dataIndex: "create_time",
    ellipsis: true,
    key: "create_time"
  },
  {
    title: "状态",
    dataIndex: "status_name",
    ellipsis: true,
    key: "status_name",
  },
  {
    title: "操作",
    key: "action",
    width: "180px",
    scopedSlots: { customRender: "action" }
  }
];
export default {
  name: "translateAll",
  data() {
    return {
      pageNum:1,
      loadingtable:true,
      description:"暂无数据",
      message:"",
      replaceFields: {children: 'children', title: 'title', key: 'id',value:"id"},
      visibleImg: false,
      tableImg: "",
      seachList: {
        name: [],
        class: [],
        status:[]
      },
      seach: {
        a_customer_id:undefined,
        name: "",
        status: undefined,
        create_time: [],
      },
      pagination: {
        pageNo: 1,
        pageSize: 20, // 默认每页显示数量
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
        onChange: this.getList.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        size: "small",
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true,
      },
      data: [],
      columns,
      selectedRowKeys: [],
      visible: false,
      title: "",
      product_ids:[],
      visibleForm: false,
      visibleAiForm: false,
      titleForm: "",
      loading: true,
      options:[],
      selectedRows:[],
      importTransData: {}
    }
  },
  created() {
    this.$store.state.adminleftnavnum = "/BatchTranslation/ProductClass"; //设置左侧导航2-2 active
  },
  mounted() {
    // this.getSeachList()
  },
  computed: {
    hasSelected() {
      return this.product_ids.length > 0;
    },
  },
  methods: {

    handleSearch: debounce(function (val)   {
      this.handleSearchFn(val)
    }, 300),
    handleSearchFn(val){
      console.log(val)
      this.options=[];
      this.seachList.name=[]
      //下拉模糊查询
      if(val){this.getSeachList(val)}
    },
    getSeachList(company){
      API.service.GET_NAME({company}).then(res => {
        this.seachList.name = res.data.data
        res.data.data.forEach((item) => {
          this.options.push({
            value: item.id,
            label: item.company,
          })
        });
      })
    },

    handleChange(value) {
      if(value==undefined)return
      this.loadingtable=true
      this.seachList.class=[]
      API.service.GET_CLASS({a_customer_id:value}).then(res => {
        this.seachList.class = res.data.data
      })
      this.product_ids=[]
      this.seachList.name.forEach((item,index)=>{
        if(item.id==value)this.message=`该公司购买字符${item.translation_set_num}个剩余字符${item.translation_surplus_num}个`
      })
      this.getList(1)
    },
    filterOption(input, option) {
      return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    submitchange(id,val){
      let ids = this.product_ids;
      API.service.TRANSLATE_PRORESUB({ids: id ? [id] : ids,a_customer_id:val? val : this.seach.a_customer_id,type:5}).then(res => {
        if (res.data.code == 200) {
          this.$message.success(res.data.msg);
          this.getList(1)
        }
      })
    },
    submitchange2(id){
      API.service.TRANSLATE_WITHDRAW({id: id}).then(res => {
        if (res.data.code == 200) {
          this.$message.success(res.data.msg);
          this.getList(1)
        }
      })
    },
    resetSeach() {
      this.loading = true
      this.message=""
      this.seach = {
        a_customer_id: this.seach.a_customer_id,
        name: "",
        status: undefined,
        create_time: []
      }
      this.seachList.class= []
      this.data=[]
      this.getList(1,"reset")
      this.$emit("resetSeach");
    },
    searchKey(){
      if(event.keyCode == 13){
        this.getList(1)
      }
    },
    getList(page,type) {
      this.loadingtable=true
      let seachData = JSON.parse(JSON.stringify(this.seach))
      if(this.seach.a_customer_id==undefined&&type!="reset"){
        this.data=[]
        this.message=""
        this.description="请先选择客户"
      }
      API.service.GET_PROLIST({page: page || this.pageNum, ...seachData, type:5, a_customer_id:this.seach.a_customer_id,}).then(res => {
        this.pageNum=page || this.pageNum
        if(res.data.code==400 &&type!="reset"){
          this.$message.destroy()
          this.$message.error(res.data.msg)
          return
        }
        this.seachList.status = res.data.data.status;

        if(res.data.data.list.data ){
          this.data = res.data.data.list.data}
        else{ this.data=[]}
        if(res.data.data.list.data.length>0){
          this.pagination.total = res.data.data.list.total
          this.pagination.pageSize = res.data.data.list.per_page
          this.pagination.current = res.data.data.list.current_page
        }else{
          this.description="暂无数据"
        }
        this.product_ids=[]
        this.loading=false
        this.loadingtable=false
      })
    },
    onSelectChange(selectedRowKeys) {
      this.product_ids = selectedRowKeys;
    },

    onSelectRow: function (record, selected, selectedRows) {
      console.log(record)
      record.checkFlag = !record.checkFlag // 更改选中row的选中状态

      // antD此版本 注：暂不支持父子数据递归关联选择。选中第一级时需要手动添一级下的所有第二级
      // 选中父级&&父级有子元素
      if(record.children){
        if ( record.children.length > 0) {
          // 判断是选中还是取消选中
          if (record.checkFlag) { // 选中
            // 手动添加选中店第二级
            this.product_ids.push(record.id) // 一级id存入到选中的key集合中
            this.selectedRows.push(record) // 一级id存入到选中的row集合中
            // 遍历选中的一级的子级 子级全部存入到选中的key集合中、row集合中
            this.recursion(record.children,record.checkFlag)
            this.selectedRows = this.selectedRows.concat(record.children)
            // 去重- 关键
            this.selectedRows = this.selectedRows.filter((x, index, self) => self.indexOf(x) === index)
          } else { // 取消选中
            // 取消本身
            console.log('取消')

            this.product_ids = this.product_ids.filter(item => item !== record.id)
            this.selectedRows = this.selectedRows.filter(item => item.id !== record.id)
            // // 手动取消一级下所有二级的选中状态
            // record.children.forEach(account => {
            //     this.product_ids.forEach((selectKey, index) => {
            //         if (account.id === selectKey) {
            //             this.product_ids.splice(index, 1)
            //         }
            //     })
            //     this.selectedRows.forEach((selectRow, index) => {
            //         if (account.id === selectRow.id) {
            //             this.selectedRows.splice(index, 1)
            //         }
            //     })
            // })
          }
        }
      }
    },
    //选中所有子集
    recursion(arr){
      arr.map(account => {
        this.product_ids.push(account.id)
        // 去重- 关键
        account.checkFlag=true
        this.product_ids = this.product_ids.filter((x, index, self) => self.indexOf(x) === index)
        if(account.children){
          this.recursion(account.children)
        }
      })
    },
  }
}

</script>

<style scoped>
.seachBox .seachList .name {
  width: 70px !important;
}

.seachBox .seachList .seachs {
  width: calc(100% - 80px);
}

.inputs {
  display: inline-block;
  width: 70px
}

</style>
